<template>
  <v-dialog v-model="dialog" max-width="600px" v-if="item">
    <v-card style="border: 1px solid #fff">
      <v-toolbar dark flat color="#042333" height="50px">
        <v-toolbar-title class="subtitle-2">{{ item.titulo }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="setDialog(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="min-height: 55vh" class="pb-0" align-center>
        <div class="px-4 pt-4">
          <div class="caption">Descrição:</div>
          <div class="font-weight-medium">
            {{ item.descricao }}
          </div>
        </div>
        <div class="px-4 pt-2" v-if="item.meta && item.meta.nome">
          <div class="caption">Autorizador:</div>
          <div class="font-weight-medium">
            {{ item.meta.nome }}
          </div>
        </div>
        <div class="px-4 pt-2" v-if="item.meta && item.meta.status">
          <div class="caption">Status:</div>
          <div
            :class="item.meta && item.meta.class ? item.meta.class : ''"
            lass="font-weight-medium"
          >
            {{ item.meta.status }}
          </div>
        </div>
        <div class="px-4 pt-2" v-if="item.meta && item.meta.observacao">
          <div class="caption">Observação:</div>
          <div class="font-weight-medium">
            {{ item.meta.observacao }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#042333" dark @click="setDialog(false)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters("notificacao", ["item", "dialog"]),
    dialog: {
      get() {
        return this.$store.state.notificacao.dialog;
      },
      set(val) {
        this.$store.commit("notificacao/setDialog", val);
      },
    },
  },
  methods: {
    ...mapMutations("notificacao", ["setDialog"]),
  },
};
</script>
